import { createContext } from "react";

const BrokerPageContext = createContext({});

export default BrokerPageContext;
